import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PChat from '../../services/PChat';
import useForceUpdate from './useForceUpdate';
import './Chat.css';

function Chat({ userId }) {
  const forceUpdate = useForceUpdate();
  const [inputValue, setInputValue] = useState(''); // New state variable for the input value
  const messagesRef = useRef(null);

  const getMessageId = (message) => message?.id;

  useLayoutEffect(() => {
    messagesRef.current.scrollTop = messagesRef.current?.scrollHeight;
  }, []);

  useEffect(() => {
    function scrollToBottom() {
      setTimeout(() => {
        messagesRef.current.scrollTop = messagesRef.current?.scrollHeight;
      }, 10);
    }

    PChat.on(PChat.Events.HISTORY_LOAD, () => {
      forceUpdate();

      scrollToBottom();
    });

    PChat.on(PChat.Events.MESSAGE, () => {
      forceUpdate();
      setTimeout(() => {
        document
          .getElementsByClassName('message')
          [document.getElementsByClassName('message').length - 1]?.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
      }, 10);
    });

    PChat.on(PChat.Events.MESSAGE_DELETE, (data) => {
      console.log('deleted', data);
      forceUpdate();
    });

    return () => {
      PChat.off(PChat.Events.MESSAGE);
      PChat.off(PChat.Events.HISTORY_LOAD);
      PChat.off(PChat.Events.MESSAGE_DELETE);
    };
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      PChat.publish(inputValue);
      setInputValue('');
    }
  };

  const handleClearRoom = async () => {
    try {
      const confirmed = window.confirm('Clear all messages in this room?');
      if (!confirmed) return;
      const result = await PChat.clearRoom();
      console.log('Room cleared:', result);
      // Force UI refresh in case SDK clears messages asynchronously
      forceUpdate();
    } catch (e) {
      console.error('Failed to clear room:', e);
    }
  };

  return (
    <>
      <div className={`chat-container`}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h5 style={{ margin: 0 }}>Chat Room</h5>
          <button
            className="chat-clear"
            onClick={handleClearRoom}
            title="Clear all messages (moderator only)"
            style={{
              border: '1px solid #ddd',
              background: '#fafafa',
              color: '#333',
              cursor: 'pointer',
              borderRadius: 4,
              padding: '2px 8px',
              fontSize: 12,
            }}
          >
            Clear
          </button>
        </div>

        <div className="messages" ref={messagesRef}>
          {PChat.messages.map((message, index) => (
            <div key={index} className={`message ${message.user.meta.username === userId ? 'self' : ''}`}>
              <div className="message-username">{message.user.meta.username}:</div>
              <div className="message-content" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ flex: 1 }}>{message.content}</span>
                <button
                  className="message-delete"
                  title="Remove message"
                  onClick={() => {
                    const id = getMessageId(message);
                    if (id) {
                      PChat.deleteMessage(id);
                    }
                  }}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    color: '#999',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>
        <input
          className="chat-input"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyPress={handleInputKeyPress}
          placeholder="Type your message here..."
        />
      </div>
    </>
  );
}

export default Chat;
